import React from "react";
import {AutoComplete, Button, Checkbox, Form, Icon, Input, Select, Row, Col, Typography} from "antd";
import {Link} from "react-router-dom";
import _ from 'lodash';
import code from "../util/code.json"
import {connect} from "react-redux";
import {
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGithubSignIn,
  userGoogleSignIn,
  userSignUp,
  userTwitterSignIn,
  userSignIn,
} from "appRedux/actions/Auth";

import IntlMessages from "util/IntlMessages";
import {message} from "antd/lib/index";
import CircularProgress from "components/CircularProgress/index";
import "./signup.less"
import {getData, fetchBank, createUser} from '../util/API'

const FormItem = Form.Item;
const Option = Select.Option;
const AutoCompleteOption = AutoComplete.Option;
const country_code= code.map((x,index) =>  <Option key={index}  value={x.dial_code}>{x.code}</Option> )
const { Text, Title } = Typography;


class SignUp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      token : localStorage.getItem('token')?localStorage.getItem('token'):null,
      cloader : false,
      agentData: null
    };

    if (this.state.token != null) {
      this.props.history.push('/registration');
    }
    this.fetchAgentList();
  }

  componentDidMount() {
    this.fetchAgentList()
  }

  fetchAgentList = () => {
    // let apiUrl = '/partner/agent-listing/';
    let apiUrl = '/partner/referred-by-listing/';
    getData(apiUrl)
      .then(res => {
        if(res.status==200){
          // this.setState({children :res.data.agents.map((x, index) => <Option key={index} value={x.full_name}>{x.full_name}</Option>)});
          this.setState({agentData:res.data.referred_by});
        }else{
          // message.error('No data found');
          console.log("#res => No data found");
        }
      }).catch(error => {
        console.log(error);
    });
  }

   handleSubmit = (e) => {

    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      // console.log("err -> ", err);
      if (!err) {
      this.setState({cloader: true});
       const user = {
        email: values.email,
        phone: values.phone ,
        country_code: values.prefix,
        username: values.userName,
        referred_by:values.referredBy? values.referredBy : null,
        company_email: values.company_email,
        company_name: values.company_name
      };
      const endpoint = '/partner/profile/'
      createUser(endpoint, user)
      .then(res => {
        if (res.data['status']===200)
        {
        localStorage.setItem('token', res.data['token']);
        localStorage.setItem('uuid', res.data['uuid']);
        localStorage.setItem('user_uuid', res.data.uuid)
        localStorage.setItem('user_role', res.data['user_role']);
        localStorage.setItem('all_roles', 'partner');
        localStorage.setItem('loged_in_to', 'orion')
        this.props.history.push('/registration');
        } else {
          this.setState({cloader: false});
          message.error(res.data['message'])
        }
      })
      .catch(error => {
        this.setState({cloader: false});
        console.log(error);
        message.error(error.toString())
      });

      }
    });
  };

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }
    if (this.state.token != null) {
      this.props.history.push('/registration');
    }
  }

  validatorEmail = (rule, value, callback) => {
    if (value !== undefined && value !== "") {
        let pattern = /^[A-Za-z0-9._%+-]+@uniserved\.com$/i;
        if (pattern.test(value)) {
          callback('Email with domain @uniserved.com is not allowed!');
        } else {
            callback();
        }

    } else {
        callback();
    }

}

  render() {
    const {getFieldDecorator} = this.props.form;
    const {showMessage, loader, alertMessage} = this.props;
    const prefixSelector = getFieldDecorator('prefix', {
      initialValue: '+91',
    })(
      <Select key = 'sel' style={{width: 70}}>
       {country_code}
      </Select>
    );
    // let dataSource = _.map(this.state.agentData, 'full_name')
    let dataSource = this.state.agentData;
    return (
      <div className="gx-app-login-wrap">
      <div className="gx-app-login-container">
        <Row type="flex" align="middle" className="gx-app-login-main-content">
            <Col xl={12} lg={12} md={12} sm={24} xs={24} className="emptySpacing" style={{ height: "100vh" }}>
              <div style={{ backgroundColor: "#630086", height: "65%" }} >
                <div style={{ height: "35%" }} ></div>
                <div style={{ height: "10%" }} >
                  <p style={{ fontSize: 60, fontFamily: "Century Font", color: "white", textAlign: "center", margin: "auto" }}>
                    Matrix
                  </p>
                </div>
                <br></br>
                <div style={{ height: "10%", fontFamily: "Century Font", textAlign: "center", margin: "auto" }} >
                  <p style={{ fontSize: 40, color: "white" }}>
                    Field Services Management
                  </p>
                </div>
                <div style={{ height: "10%" }} ></div>

              </div>
              <div style={{ backgroundColor: "white", height: "35%" }}>
                <div style={{ height: "15%" }} ></div>
                <div style={{ height: "10%", textAlign: "center", margin: "auto" }} >
                  <img src={require('assets/images/LogoUniserved.png')} alt='Neature' />
                </div>
                <div style={{ height: "10%" }} ></div>
              </div>
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24} className="emptySpacing">
            <div style={{ boxShadow: "0px 0px 10px lightgray", height: "100vh" }} >
                <div style={{ height: "5%" }} ></div>
              <div className="gx-app-login-content">
              <Title level={2}>Sign Up</Title>
              <Text style={{fontSize:'18px'}}>SignUp to manage your projects and showcase your skills. Matrix is the one stop interface between you and Uniserved.</Text>
                <Form onSubmit={this.handleSubmit} className="gx-signup-form gx-form-row0 gx-mt-4">
                  <FormItem label={(
                    <span>
                    Your Name

                  </span>
                  )}>
                    {getFieldDecorator('userName', {
                      rules: [{required: true, message: 'Please input your Name!'}],
                    })(
                      <Input placeholder="Name"/>
                    )}
                  </FormItem>

                  <FormItem label={(
                    <span>
                    Official Email ID

                  </span>
                  )}>
                    {getFieldDecorator('email', {
                      rules: [{ required: true, type: 'email', message: 'The input is not valid E-mail!' }, { validator: this.validatorEmail }],                      
                    })(
                      <Input placeholder="Official Email ID"/>
                    )}
                  </FormItem>

                  <FormItem label={(
                    <span>
                    Phone

                  </span>
                  )}>
                    {getFieldDecorator('phone', {
                      rules: [{required: true, message: 'Please input your phone number!'}],
                    })(
                      <Input addonBefore={prefixSelector} style={{width: '100%'}}/>
                    )}
                  </FormItem>
                  <FormItem label={(
                    <span>
                    Company Name
                  </span>
                  )}>
                    {getFieldDecorator('company_name', {
                      rules: [{required: true, message: 'Please input your Company Name!'}],
                    })(
                      <Input placeholder="Company Name"/>
                    )}
                  </FormItem>
                  <FormItem label={(
                    <span>
                    Company Email(Can be the same as the email ID above)

                  </span>
                  )}>
                    {getFieldDecorator('company_email', {
                      rules: [{ required: true, type: 'email', message: 'The input is not valid E-mail!' }, { validator: this.validatorEmail }],  
                    })(
                      <Input placeholder="Company Email"/>
                    )}
                  </FormItem>

                  <FormItem label={(
                    <span>
                    Who referred you?
                  </span>
                  )}>
                    {getFieldDecorator('referredBy', {
                      rules: [{
                        required: false,
                      }],
                    })(
                      <AutoComplete
                        dataSource={dataSource}
                        placeholder="Referer Name"
                        filterOption={(inputValue, option) => option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                      />
                    )}
                  </FormItem>
                  <FormItem>
                    {getFieldDecorator('remember', {
                      valuePropName: 'checked',
                      rules: [{required: true, message: 'Please accept the Term & Condition'}],
                    })(
                      <Checkbox><IntlMessages id="appModule.iAccept"/></Checkbox>
                    )}
                    <span className="gx-link gx-signup-form-forgot"><IntlMessages
                      id="appModule.termAndCondition"/></span>
                  </FormItem>
                  <FormItem>
                    <Button type="primary" className="gx-mb-0" htmlType="submit">
                      <IntlMessages id="app.userAuth.signUp"/>
                    </Button>
                    <span><IntlMessages id="app.userAuth.or"/></span> <Link to="/signin"><IntlMessages
                    id="app.userAuth.signIn"/></Link>
                  </FormItem>

                </Form>
              </div>
              </div>
              {this.state.cloader &&
              <div className="gx-loader-view">
                <CircularProgress/>
              </div>
              }
              {showMessage &&
              message.error(alertMessage)}
            </Col>
        </Row>
      </div>
      </div>
    );
  }

}

const WrappedSignUpForm = Form.create()(SignUp);

const mapStateToProps = ({auth}) => {
  const {loader, alertMessage, showMessage, authUser} = auth;
  return {loader, alertMessage, showMessage, authUser}
};

export default connect(mapStateToProps, {
  userSignUp,
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGoogleSignIn,
  userGithubSignIn,
  userTwitterSignIn
})(WrappedSignUpForm);
